import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "button"
    ]

    static values = {
        textHide: String
    };
    connect() {
        if (!this.hasButtonTarget) {
            // No toggle button rendered (≤3 specialisms case) — nothing to manage.
            return
        }
        this.isExpanded = false
        this.textShow = this.buttonTarget.textContent.trim()
    }

    toggle(event) {
        event.preventDefault()

        if (!this.hasButtonTarget) {
            return
        }

        // Find all hidden specialism items
        const hiddenItems = this.element.querySelectorAll('[data-specialism-hidden="true"]')

        // Toggle visibility
        hiddenItems.forEach(item => {
            item.classList.toggle('d-none')
        })

        // Toggle button text
        this.isExpanded = !this.isExpanded
        this.buttonTarget.textContent = this.isExpanded ? this.textHideValue : this.textShow
    }
}
